import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import SubmitButton from "../../form/SubmitButton";
import FileUpload from "../../form/FileUpload";


interface Props {
  imageUrl: string;
  id:number;
  onSubmitSuccess?: () => void;
}

const UpdateAvatarForm: React.FC<Props> = ({ imageUrl, id,onSubmitSuccess }) => {
  const { t } = useTranslation();

     const [avatar, setAvatar] = useState<File | null>(null)
  
  
      const {loading,updateResource} = useUpdateResource();
  
     
       const onSubmit = (e:  React.FormEvent<HTMLFormElement>) => {
         // call API to create category
         e.preventDefault();
         if(!avatar){
             alert(t('upload_image_required'));
             return;
         }
         const formData = new FormData();
         if(avatar){
             formData.append("image",avatar);
         }
         updateResource(`avatar/${id}`, formData,
             "admin",{
                 method: "PUT",
                 successMessage: t("update_success"),
                 invalidateQueries:["avatars-by-admin"],
               });
          if(onSubmitSuccess)onSubmitSuccess();
       };

  return (
    <form
      onSubmit={(e)=>(onSubmit(e))}
      className="grid gap-4"
    >
      <FileUpload
        file={avatar}
        setFile={setAvatar}
        label={t("")}
        addText={t("add_avatar")}
        shape="circle"
        size={128}
        initial={imageUrl}
        />

    {
        loading
        ?
        <LoadingButton/>
        :
        <SubmitButton label={t("update")} />
    }
    </form>
  );
};

export default UpdateAvatarForm;
